import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "position-relative" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: _normalizeClass(["cartcount_indicator", _ctx.isCartFilled ? 'active' : ''])
        }, null, 2),
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icon-brand_shopping [ JS_blueCartButton JS_header_toggle_interactive ]" }, null, -1))
    ]));
}
